<template>
  <v-card class="magazine-card" :to="to" flat>
    <picture>
      <img
        @error="onError"
        loading="lazy"
        :src="parsedImg"
        :alt="title"
        width="100%"
      />
    </picture>

    <div class="magazine-card_title text-center text-body-1 font-weight-bold">
      {{ parsedTitle }}
    </div>
    <v-btn
      v-if="file"
      @click="downloadFile"
      class="text-none mt-2"
      color="secondary"
      block
      depressed
    >
      <v-icon small left>fas fa-download</v-icon>
      <span>Download</span>
    </v-btn>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";
import { formatToURL } from "../../utils/formatToURL";

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    img: {
      type: String,
      default: DefaultImg,
    },
    title: {
      type: String,
      required: true,
    },
    file: {
      type: String,
    },
  },
  data: () => ({
    width: null,
  }),
  computed: {
    parsedTitle() {
      return this.title?.replace(/\\"/g, '"');
    },
    parsedImg() {
      if (!this.width) {
        return null;
      }

      let img = "";

      if (!/^https?:\/\//.test(this.img)) {
        img = this.files;
      }

      img += this.img;

      return `${img}?resize=1&w=${this.width}`;
    },
    to() {
      const slug = formatToURL(this.title);

      return `/almanaque/${slug}-${this.id}`;
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
    downloadFile() {
      const fileUrl = this.files + this.file;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = this.title;
      link.target = "_blank";

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    },
  },
  mounted() {
    this.width = this.$el.clientWidth;
  },
};
</script>

<style lang="scss">
.magazine-card {
  img {
    aspect-ratio: 195 / 555;
  }
}
</style>
